import React, { useState, useEffect }from 'react';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import 'react-toastify/dist/ReactToastify.css';
import { DataGridPro } from '@mui/x-data-grid-pro';

const LicenceRevenueForm = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    useEffect (()=>{
        try{
            SftGlobalData.post('client&action=revenue', {key: props.api}).then(response => {
                setData(response.data);
                setLoading(false);
            });
        } catch(e){
            console.error(e);
        }
    }, [props.api]);

    const gridWebhookColumns = [
        {
            field: 'id',
            headerName: 'ID',
            minWidth: 75,
            width: 75,
            align: "left",
            display: 'flex',
        },
        {
            field: 'login',
            headerName: 'Login',
            width: 250,
            align: "left",
            display: 'flex',
        },
        {
            field: 'fname',
            headerName: 'First name',
            width: 150,
            align: "left",
            display: 'flex',
        },
        {
            field: 'name',
            headerName: 'Last name',
            width: 200,
            align: "left",
            display: 'flex',
        },
        {
            field: 'last_login',
            headerName: 'Last login',
            width: 200,
            align: "left",
            display: 'flex',
        }
      ];

    function DataGrid() {
        return (
          <div className={props.theme} style={{width: '100%'}}>
            <input 
                type="text"
                name="search"
                className={props.theme+"_accent_darker "}
                style={{marginTop: 0 }}
                placeholder={props.t('search')}
                value={searchValue}
                onChange={e => setSearchValue(e.target.value)}
            />
            
            {props.accountId != "0" && <DataGridPro
                className={props.theme}
                columns={gridWebhookColumns}
                rows={data.filter(row => (row.id?.toString().match(new RegExp(searchValue, "i")) || row.login.match(new RegExp(searchValue, "i")) || row.last_login.match(new RegExp(searchValue, "i")) || row.name.match(new RegExp(searchValue, "i")) || row.fname.match(new RegExp(searchValue, "i"))))
                .map((row, index) => {return {
                        id: row.id,
                        login: row.login,
                        name: row.name,
                        fname: row.fname,
                        last_login: row.last_login
                    }
                })}
                rowHeight={38}
                style={{height: 400}}
                pagination={true}
                loading={loading}

                />   }       
          </div>
        );
    }


    return (
        <div>
            {DataGrid()}
        </div>
    );
}

export default LicenceRevenueForm;
